"use strict";
jQuery(document).ready(function($) {
    var valueArray = [ "title", "content", "merk", "categorie" ];
    $(".filter-item.merken button").each(function(i) {
        valueArray.push($(this).data("value"));
    });
    $(".filter-item.categorieen button").each(function(i) {
        valueArray.push($(this).data("value"));
    });
    console.log(valueArray);

    var documentList = new List("document-list", {
        valueNames: valueArray,
        page: 12,
        pagination: true
    });

    $('.search-input').on('submit', function(ev) {
		ev.preventDefault();
		var searchText = $("#searchText").val();
        
        documentList.search(searchText);
		
    });
    $(".filter-item button").on("click", function(ev) {
        
       
        if($(this).parent().hasClass('merken')){
            $('.filter-item.merken button').removeClass('active');
            $(this).toggleClass('active');
            $('.filter-item.categorieen button').removeClass('active');
            $('.filter-item.categorieen .categorie').click ();
            
        } else {
            $('.filter-item.categorieen button').removeClass('active');
            $(this).toggleClass('active');
        }
       
        var $categoryText = $(".filter-item.categorieen button.active").text();
        var $merkText = $(".filter-item.merken button.active" ).text();
		var $categoryClass = $(".filter-item.categorieen button.active").data('value');
        var $merkClass = $(".filter-item.merken button.active" ).data('value');
        
 

        

        if($categoryClass == 'Alles' && $merkClass == 'Alles') {
            documentList.filter();
            
            }else if($categoryClass == 'Alles' && $merkClass != 'Alles') {
                documentList.filter(function(item) {
                    
                if(item.values()[$merkClass] == $merkText  ) {
                    
                    return true;
                
                } else {
                    
                    return false;
                    
                }
            });
        }else if($merkClass == 'Alles' && $categoryClass != 'Alles') {
            documentList.filter(function(item) {
                if(item.values()[$categoryClass] == $categoryText  ) {
                    
                    return true;
                
                } else {
                    
                    return false;
                    
                }
            });
        } else {
            documentList.filter(function(item) {
                if(item.values()[$categoryClass] == $categoryText && item.values()[$merkClass] == $merkText  ) {
                    
                    return true;
                
                } else {
                    
                    return false;
                    
                }
            });
        }
        if($categoryClass == 'Alles'){
            //CREATE EMPTY BUTTON ARRAY
            var matchingButtons = ['Alles'];

            documentList.matchingItems.forEach(function(item) {
                var itemValues = item.values();
                for(var propt in itemValues){
                    if(itemValues[propt]){
                        matchingButtons.push(propt);
                    }
                }
            
            });
            
            //HIDE EMPTY BUTTONS
            $(".filter-item.categorieen button").each(function(button) {

                if(matchingButtons.indexOf($(this).data("value")) === -1) {
                    $(this).addClass("inactive");
                }else {
                    $(this).removeClass("inactive");
                }

            });
        }
        
    });

    

    
});